/*
 * @Descripttion: 
 * @version: 
 * @Author: ared
 * @Date: 2023-02-08 19:52:09
 * @LastEditors: ared
 * @LastEditTime: 2023-02-09 13:55:09
 */
export const downloadFile = (file, filename:string) => {
  let myBlob
  if(file instanceof Blob) myBlob = new Blob([file])
  let linkDom = document.createElement('a')
  linkDom.href = URL.createObjectURL(myBlob)
  linkDom.download = filename
  document.body.appendChild(linkDom)
  linkDom.click()
  document.body.removeChild(linkDom)
}